import React, { useEffect, useState } from 'react';
import classNames from 'classnames';

import './LineClamp.scss';

interface LineClampProps {
  children: string; // The actual text to be clamped
  disableLessMore?: boolean;
  moreText?: string; // the "Read more" literal when text is clamped.
  lessText?: string; // the "Read Less" literal when text is clamped.
  maxChars?: number; // Maximum allowed characters
  // If text is clamped, the characters of the remaining text should be at least this number of chars long to crop
  offsetToleranceChars?: number;
  smallText?: boolean;
}

const LineClamp = ({ children,
                     maxChars = 250,
                     moreText = 'More',
                     lessText = 'Less',
                     offsetToleranceChars = 20,
                     disableLessMore = false,
                     smallText = false
                   }:
    LineClampProps) => {
  if (children === undefined || children.length === 0) {
    // tslint:disable-next-line:no-null-keyword
    return null;
  }
  const offsetToleranceDiff = children.length - maxChars;
  const [ textReachedLimit, setTextReachedLimit ] = useState(children.length >= maxChars && offsetToleranceDiff > offsetToleranceChars);
  const [ textExpanded, setTextExpanded ] = useState(false);
  const [ modifiedText, setModifiedText ] = useState(children);

  useEffect(() => {
    let modifiedTextTemp = children.trim();
    const tempReachedLimit = children.length >= maxChars && (children.length - maxChars) > offsetToleranceChars;

    setTextReachedLimit(tempReachedLimit);

    if (tempReachedLimit && !textExpanded) {
      modifiedTextTemp = modifiedTextTemp.slice(0, maxChars);
      const lastSpaceIndex = modifiedTextTemp.lastIndexOf(' ');
      // Do not cut the words in half
      if (lastSpaceIndex !== -1) {
        modifiedTextTemp = modifiedTextTemp.slice(0, lastSpaceIndex);
      }
      // Add ellipsis
      modifiedTextTemp += ' ..';
    }

    setModifiedText(modifiedTextTemp);

  }, [children, textExpanded]);

  return (
    <div styleName="multiline-crop">
        <div styleName={
          classNames({
            'multiline-crop__text': true,
            'multiline-crop__text--open': textExpanded,
            'multiline-crop__text--small-text': smallText
          })}
        >
          {modifiedText}
          { !disableLessMore && textReachedLimit &&
            <span styleName="multiline-crop__more" onClick={() => setTextExpanded(!textExpanded)}>
              {textExpanded ? lessText : moreText}
            </span>
          }
        </div>
    </div>
  );
};

export default LineClamp;
